import '../styles/privacy-policy-screen.scss'

function PrivacyPolicyScreen() {
  return (
    <div id="privacy-policy-screen" className='full-screen'>
      <h2 className='mb-4'>Privay Policy</h2>

      <h1 className="display-6 mt-5">Thank you for using HeyArt!</h1>

      <p>
        Our mission is to bring everyone the inspiration to create an art they love.
        To do that, we show you personalised content and ads we think you'll be interested in based on information we collect from you and third parties.
        We only use that information where we have a proper legal basis for doing so.
      </p>

      <p>
        We wrote this policy to help you understand what information we collect,
        how we use it and what choices you have about it.

        As we're an Internet company, some of the concepts below are a little technical,
        but we've tried our best to explain things in a simple and clear way. We welcome your questions and comments on this policy.
      </p>


      <h4 className='mt-4 mb-3'>We collect information in a few different ways</h4>

      <h6>1. When you give it to us or give us permission to obtain it</h6>
      <p>
        When you sign up for or use HeyArt,
        you voluntarily share certain information including your name, email address, profile picture, coloring history, comments and any other information you give us.
      </p>

      <p>
        If you connect your Facebook, Google or other third-party accounts to HeyArt,
        we use information from those accounts (such as your email and profile picture) to complete the sign up process.
      </p>

      <h6 className='mt-4'>2. We also get technical information when you use HeyArt</h6>
      <p>
        When you use a website, mobile application or other Internet service,
        certain Internet and electronic network activity information gets created and logged automatically.
        This is also true when you use HeyArt.
      </p>

      <p>
        Here are some of the types of information we collect:
      </p>

      <ul>
        <li className='mb-2'>
          <strong>Log data.</strong> When you use HeyArt, our servers record information (“log data”),
          including information that your browser automatically sends whenever you visit a website,
          or that your mobile app automatically sends when you're using it.
          This log data includes your Internet Protocol address (which we use to infer your approximate location),
          the address of and activity on websites you visit that incorporate HeyArt features (such as the “Save” button – more details below),
          searches, the date and time of your request, how you used HeyArt, cookie data and device data.
        </li>
        <li className='mb-2'>
          <strong>Cookie data.</strong> We also use “cookies” (small text files sent by your computer each time you visit our website,
          unique to your HeyArt account or your browser) or similar technologies to get log data.
          When we use cookies or other similar technologies, we use session cookies (that last until you close your browser)
          or persistent cookies (that last until you or your browser delete them).
          For example, we use cookies to store your language preferences or other settings so you don't have to set them up every time you visit HeyArt.
          Some of the cookies we use are associated with your HeyArt account (including information about you, such as the email address you gave us) and other cookies are not.
        </li>
        <li className='mb-2'>
          <strong>Device information.</strong> In addition to log data, we collect information about the device you're using HeyArt on,
          including the type of device, operating system, settings, unique device identifiers and crash data that helps us understand when something breaks.
        </li>
      </ul>

      <p>
        We have a legitimate interest in making HeyArt safe and improving our product features so you keep finding the inspiration you want.
        We also have a legitimate interest in delivering ads that are relevant, interesting and personal to you in order to generate revenue.
      </p>

      <p>
        To further these interests, we use the information we collect to:
        Decide which ads to show you.
        For example, if you show an interest in sports on HeyArt, we may show you ads for sports products.
        We customise the ad content we show you by identifying your interests based on your onsite activities,
        Where we use cookies to identify your offsite interests, we'll get your consent where we need to.
        Where ad partners or other third parties share information with us about you, we rely on the consent they have already obtained.
      </p>

      <p>
        Choices you have about your info:
        Our goal is to give you simple and meaningful choices regarding your information.
        If you have a HeyArt account, many of these controls are built directly into HeyArt or your settings.
        For example, you can:
      </p>

      <ul>
        <li className='mb-2'>
          <strong>Edit personal information</strong> in your profile at any time. For example, your display name that is visible to everyone.
        </li>
        <li className='mb-2'>
          <strong>Edit your posts.</strong> Your posts are shared wtih everyone by default. You can make some posts as "private" and they will be only visible to you.
        </li>
        <li className='mb-2'>
          <strong>Close your account at any time.</strong>
          When you close your account, we'll deactivate it, remove your posts and coloring history, and delete your account data.
          Please note that there may be legal reasons for us to keep your data, such as if we receive a law enforcement request asking us to preserve data.
          We may also retain certain information in our backup systems for a limited period of time, or as required by law.
        </li>
      </ul>

      <p>
        You also have choices available to you through the device or software you use to access HeyArt. For example:
      </p>
      <ul>
        <li className='mb-2'>
          The browser you use lets you control cookies or other types of local data storage.
        </li>
        <li className='mb-2'>
          Your mobile device lets you choose how and whether your precise location, photos, contacts and other data are shared with us.
        </li>
      </ul>

      <h4 className='mt-4 mb-2'>Our policy on children's information</h4>
      <p>
        Children under 13 years of age are allowed to use HeyArt without creating an account. No personal information will be stored.
        If you are based in the EEA, you can only use HeyArt if you are over the age at which you can provide consent to data processing under the laws of your country.
      </p>

      <p>
        If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us.
        If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent,
        We take steps to remove that information from Our servers.
      </p>

      <h4 className='mt-4 mb-2'>Security of Your Personal Data</h4>
      <p>
        The security of Your Personal Data is important to us,
        but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure.
        While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
      </p>
      <p>
        Request access to the information we collect and hold about you.
        We'll usually share this with you within 30 days of you asking us for it through our contact methods below.
      </p>


      <h4 className='mt-4 mb-2'>Links to Other Websites</h4>
      <p>
        Our Service does not contain links to other websites that are not operated by Us.
      </p>

      <h4 className='mt-4 mb-2'>Changes to this Privacy Policy</h4>
      <p>
        How we make changes to this policy
        We may change this policy from time to time. If we do, we'll post any changes on this page.
        If you continue to use HeyArt after the changes come into effect, you agree to the new policy.
        If the changes are significant, we may provide a more prominent notice or get your consent, as required by law.
      </p>

      <h4 className='mt-4 mb-2'>Contact us</h4>
      <p>
        The best way to get in touch with us or to exercise your options described above is through<br />
        our contact from or send us an email to <a href="mailto: contact.heyart.app@gmail.com">contact.heyart.app@gmail.com</a>.
      </p>

      <hr />

      <small>
        Effective date 1 October 2022 (last updated 1 October 2022).
      </small>
    </div>
  )
}

export default PrivacyPolicyScreen
